import { h } from 'preact';
import { Router } from 'preact-router';

import Footer from './footer';
import Home from '../routes/home';
import Fairness from '../routes/fairness';

import Mines from '../routes/mines';
import Dice from '../routes/dice';
import Ninja from '../routes/ninja';
import Tower from '../routes/tower';
import Slots from '../routes/slots';
import Stairs from '../routes/stairs';
import Bubbles from '../routes/bubbles';
import Plinko from '../routes/plinko';
import Hilo from '../routes/hilo';
import Keno from '../routes/keno';
import Wheel from '../routes/wheel';
import Blackjack from '../routes/blackjack';
import Coinflip from '../routes/coinflip';
import X777 from '../routes/777';
import Triple from '../routes/triple';
import Roulette from '../routes/roulette';
import Twist from '../routes/twist';
import Baccarat from '../routes/baccarat';
import VideoPoker from '../routes/video-poker';
import Crash from '../routes/crash';

const App = () => {
  return (
    <div id="app">
      <div class="container">
        <Router>
          <Home path="/" />
          <Mines path="/mines" />
          <Dice path="/dice" />
          <Ninja path="/ninja" />
          <Tower path="/tower" />
          <Slots path="/slots" />
          <Stairs path="/stairs" />
          <Bubbles path="/bubbles" />
          <Plinko path="/plinko" />
          <Hilo path="/hilo" />
          <Keno path="/keno" />
          <Wheel path="/wheel" />
          <Blackjack path="/blackjack" />
          <Coinflip path="/coinflip" />
          <X777 path="/777" />
          <Triple path="/triple" />
          <Roulette path="/roulette" />
          <Twist path="/twist" />
          <Baccarat path="/baccarat" />
          <VideoPoker path="/video-poker" />
          <Crash path="/crash" />
          <Fairness path="/fairness" />
        </Router>
      </div>
      <Footer />
    </div>
  );
};

export default App;
